import path from 'path'

export const root = path.join(__dirname, '../../../')

export default {
  root,
  public: `${root}public`,
  src: {
    root: `${root}src`,
    components: `${root}/src/components`,
    pages: `${root}/src/pages`,
    reducks: `${root}/src/reducks`,
    integration: `${root}/src/integration`,
    lib: `${root}/src/lib`
  },
  dist: {
    root: `${root}dist`,
    assets: `${root}dist/assets`
  }
}
